import Vue from "vue";
import vueFilters from "./cart-filters";

function initProductApp() {
    var el = document.getElementById("product-app");
    var form = document.getElementById("product-form");
    if (!el) return;
    var token = el.getAttribute("data-token");

    var app = new Vue({
        el: el,
        delimiters: ["${", "}"],
        filters: vueFilters,
        data: {
            loading: true,
            title: "",
            variant: 0,
            price: 0,
            salePrice: 0,
            amount: el.dataset.minAmount,
            guarantees: [],
        },
        mounted: async function() {
            this.loading = false;
            this.title = form.dataset.title;
            this.variant = parseFloat(form.dataset.variant);
            this.price = parseFloat(form.dataset.price);
            this.salePrice = parseFloat(form.dataset.salePrice);
            this.guarantees = JSON.parse(form.dataset.guarantees);
        },
        computed: {},
        methods: {
            changePrice: async function(e) {
                // e.preventDefault();
                this.variant = parseFloat(e.target.value);
                this.price = parseFloat(e.target.dataset.price);
                this.salePrice = parseFloat(e.target.dataset.salePrice);
                this.guarantees = JSON.parse(e.target.dataset.guarantees);
                this.amount = 1;
            },
            addToCart: async function(e) {
                e.preventDefault();
                window.cart.addToCart(this.variant, this.amount, this.guarantees);
                window.openCart();
            }
        },
        watch: {}
    });
    // window.cart = app;
}

export default function init() {
    initProductApp();
}
